<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4"  v-if="currentTrailType">
          <div class="card-header pt-1 pb-0">
            <div>
              <h3 class="card-title text-primary mb-0">Tipología de ruta "{{ currentTrailType.name }}"</h3>
              <div class="sub-line"></div>
              <div class="row col-12 mt-3">
                <router-link :to="{ name: 'TrailTypes' }"
                             class="col-md-2 col-6 col-md-offset-10 btn btn-primary btn-sm text-white bg-blue-600 rounded-lg hover:bg-blue-900 mb-0  ml-auto">
                  Ir al listado
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body">
             <div class="row">
               <div class="col-md-6">
                 <div class="card">
                    <div class="card-body">
                      <label for="department_name" class="form-control-label">
                        Nombre
                      </label>
                      <p>{{ currentTrailType.name }}</p>

                      <label for="description" class="form-control-label">
                        Descripción
                      </label>
                      <p>{{ currentTrailType.description }}</p>

                      <label for="lang" class="form-control-label">
                        Idioma
                      </label>
                      <p>{{ currentTrailType.lang }}</p>

                      <label for="order_number" class="form-control-label">
                        Número de Orden
                      </label>
                      <p>{{ currentTrailType.orderNumber }}</p>

                      <label for="image" class="form-control-label">
                        Imagen
                      </label>
                      <div class="col-12" v-if="currentTrailType.image">
                        <img class="img-thumbnail" width="200" :src="currentTrailType.image.imageUrl">
                      </div>
                    </div>
                 </div>

               </div>
               <div class="col-md-6">
                 <div class="card">
                    <div class="card-body">
                      <label for="icon_image" class="form-control-label">
                        Imagen Icono
                      </label>
                      <div class="col-12" v-if="currentTrailType.iconImage">
                        <img class="img-thumbnail" width="200" :src="currentTrailType.iconImage.imageUrl">
                      </div>

                      <label for="video" class="form-control-label mt-3">
                        Video
                      </label>
                      <div class="col-12" v-if="currentTrailType.videoUrl">
                        <video class="img-thumbnail" width="100%" muted controls :src="currentTrailType.videoUrl"></video>
                      </div>
                      <p v-else class="text-muted">Sin video</p>
                    </div>
                 </div>

               </div>
             </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
//import { ref } from "vue";
import { useStore } from "vuex";
import {computed, onMounted} from "vue";
import { useRoute } from "vue-router";


    const route = useRoute();
    const store = useStore();

    const getCurrentTrailType = async (id) => {
      return await store.dispatch("trailType/getTrailTypeById", id);
    };

    const currentTrailType = computed(() => store.state.trailType.currentTrailType);

    onMounted(() => {
      getCurrentTrailType(route.params.id)
    });



</script>
